import {Component, Input} from '@angular/core';

import {DetailFieldTypes, DetailParams, DetailRow} from '../../models';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DetailComponent {
  _params: any = null;
  @Input() title: string = null;

  dataList: DetailParams[] = [];
  detailFieldTypes = DetailFieldTypes;

  constructor() { }

  @Input()
  get params(): any {
    return this._params;
  }

  set params(params: any) {
    this._params = params;
    this.update();
  }

  update(){
    if(this.params){
      if(this.isArray(this.params)){
        this.dataList = this.params;
      }
      else{
        this.dataList = [this.params];
      }
    }
  }

  isArray(obj: any): boolean {
    return Array.isArray(obj);
  }

  isAttachment(field: DetailRow){
    return field.type && field.type === DetailFieldTypes.attachment;
  }
}
